import { useAuthStore } from '@tundr/auth';
import { NotFound } from '@tundr/ui-kit';
import type { RouteRecordRaw } from 'vue-router';
import AppRouter from '@bo/modules/app/AppRouter.vue';
import { bankTransfersRoutesConfig } from '@bo/modules/app/bank-transfers/routes/bank-transfers-routes.ts';
import { billingRoutesConfig } from '@bo/modules/app/billing/routes/billing-routes-config.ts';
import { cardOrderRoutesConfig } from '@bo/modules/app/card-orders/routes/card-order-routes-config.ts';
import { companiesRoutesConfig } from '@bo/modules/app/company/routes/company-routes-config.ts';
import { fringeRoutesConfig } from '@bo/modules/app/fringe/routes/fringe-routes-config.ts';
import { overBudgetEmployeeRoutesConfig } from '@bo/modules/app/over-budget-employee/routes/over-budget-employee-routes.config.ts';
import { paymentValidationKeywordsRoutesConfig } from '@bo/modules/app/payment-validation-keywords/routes/payment-validation-keywords-routes.ts';
import { paymentsRoutesConfig } from '@bo/modules/app/payments/routes/payments-routes.ts';
import { pensionFundRoutesConfig } from '@bo/modules/app/pension-funds/routes/pension-fund-routes-config.ts';
import { reimbursementsRoutesConfig } from '@bo/modules/app/reimbursement/routes/reimbursement-routes-config.ts';
import { reportsRoutesConfig } from '@bo/modules/app/reports/routes/reports-routes-config.ts';
import { subscriptionRoutesConfig } from '@bo/modules/app/subscription/routes/subscription-routes-config.ts';
import { supplierVouchersRoutesConfig } from '@bo/modules/app/supplier-voucher-reports/routes/supplier-vouchers-routes-config.ts';
import { suppliersRoutesConfig } from '@bo/modules/app/suppliers/routes/suppliers-routes.ts';
import { usersRoutesConfig } from '@bo/modules/app/users/routes/users-routes.ts';
import { authRoutesConfig } from '@bo/modules/auth/routes/auth-routes.config.ts';
import { sessionInitGuard } from '../lifecycle-hooks/session-init-guard';
import { appRoutesDictionary } from './routes.dictionary';
import { vouchersRoutesConfig } from '@bo/modules/app/vouchers/routes/vouchers-routes.config.ts';
import { mealVouchersRoutesConfig } from '@bo/modules/app/meal-vouchers/routes/meal-vouchers-routes.config.ts';
import { depositRoutesConfig } from '@bo/modules/app/deposit/routes/deposit-routes.config.ts';
import { brandsRoutesConfig } from '@bo/modules/app/brands/routes/brands-routes.ts';
import { resellerRoutesConfig } from '@bo/modules/app/reseller/routes/reseller-routes.ts';
import { voucherCodesMonitorRoutesConfig } from '@bo/modules/app/voucher-codes-monitor/routes/voucher-codes-monitor-routes-config.ts';
import { healthFundRoutesConfig } from '@bo/modules/app/health-funds/routes/health-fund-routes-config.ts';
import { welfareAssignmentsRoutesConfig } from '@bo/modules/app/welfare-assignments/routes/welfare-assignments-routes-config.ts';
import { reversalRoutesConfig } from '@bo/modules/app/reversal/routes/reversal-routes-config.ts';
import { completePlanReversalRoutesConfig } from '@bo/modules/app/reversal/routes/complete-plan-reversal-routes-config.ts';

export const routes: RouteRecordRaw[] = [
  { ...appRoutesDictionary.root.notFound, component: NotFound },
  {
    ...appRoutesDictionary.root.root,
    redirect: { name: appRoutesDictionary.auth.root.name },
  },
  {
    ...authRoutesConfig,
    beforeEnter: () => {
      const authStore = useAuthStore();
      return !authStore.isLogged || { name: appRoutesDictionary.root.app.name };
    },
  },
  {
    ...appRoutesDictionary.root.app,
    redirect: { name: appRoutesDictionary.users.root.name },
    component: AppRouter,
    children: [
      suppliersRoutesConfig,
      companiesRoutesConfig,
      reimbursementsRoutesConfig,
      reportsRoutesConfig,
      bankTransfersRoutesConfig,
      subscriptionRoutesConfig,
      overBudgetEmployeeRoutesConfig,
      billingRoutesConfig,
      paymentsRoutesConfig,
      fringeRoutesConfig,
      cardOrderRoutesConfig,
      usersRoutesConfig,
      supplierVouchersRoutesConfig,
      paymentValidationKeywordsRoutesConfig,
      pensionFundRoutesConfig,
      vouchersRoutesConfig,
      mealVouchersRoutesConfig,
      depositRoutesConfig,
      brandsRoutesConfig,
      resellerRoutesConfig,
      voucherCodesMonitorRoutesConfig,
      healthFundRoutesConfig,
      welfareAssignmentsRoutesConfig,
      reversalRoutesConfig,
      completePlanReversalRoutesConfig,
    ],
    beforeEnter: sessionInitGuard,
  },
];
